import React, { useState, useEffect } from "react";
import { Image } from "antd";
import { PictureOutlined } from "@ant-design/icons";
import http from "../../../../../services/http";

export function RenderImage({ idImagem }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idImagem) return;
    const fetchImage = async () => {
      setLoading(true);
      const api = await http("file", `v1/treinamentos_materiais/carregar_arquivo/${idImagem}`);
      if (api.statusCode === 200) {
        const url = window.URL.createObjectURL(api.response.data);
        setData(url);
      }
      setLoading(false);
    };
    fetchImage();
  }, [idImagem]);

  if (loading || !data) {
    return (
      <div className="image-content">
        <div className="image-loading">
          <PictureOutlined />
        </div>
      </div>
    );
  }

  return (
    <div className="image-content justify-center" style={{ maxWidth: "100%", height: "100%" }}>
      <Image src={data} style={{ maxWidth: "100%" }} className="render-image" />
    </div>
  );
}
